import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

// إنشاء الـ Context الخاص بالمنتجات علشان نقدر نشاركه بين الصفحات
const ProductContext = createContext();

// مزود الـ Context اللي بيلف حوالين الأب (Provider)
export function ProductProvider({ children }) {
  // حالة لتخزين كل المنتجات
  const [products, setProducts] = useState([]);

  // حالة لتحديد إذا كان فيه تحميل ولا لأ
  const [loading, setLoading] = useState(true);

  // حالة لتخزين المنتج المحدد (لو عايز تعرض تفاصيل منتج معين مثلاً)
  const [selectedProduct, setSelectedProduct] = useState(null);

  // عند تحميل الصفحة، بنجيب البيانات من الـ API
  useEffect(() => {
    axios.get('https://fakestoreapi.com/products') // جلب المنتجات من API
      .then(res => setProducts(res.data)) // حفظ المنتجات في الحالة
      .catch(err => console.error('❌ خطأ في تحميل المنتجات:', err)) // طباعة الخطأ لو حصل
      .finally(() => setLoading(false)); // مهما حصل، بنوقف التحميل
  }, []);

  // دالة لتحديد منتج معين (ممكن تستخدمها لو عندك صفحة تفاصيل منتج)
  const selectProduct = (product) => {
    setSelectedProduct(product);
  };

  // تمرير البيانات والدوال لكل العناصر اللي جوه الـ Provider
  return (
    <ProductContext.Provider value={{ 
      products,       // كل المنتجات
      loading,        // حالة التحميل
      selectedProduct, // المنتج المحدد
      selectProduct   // دالة لتحديد المنتج
    }}>
      {children}
    </ProductContext.Provider>
  );
}

// هوك مخصص لاستخدام الكونتكست في أي مكون بطريقة أسهل
export const useProducts = () => useContext(ProductContext);
